/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var windowW = $(window).width();
	var windowH = $(window).innerHeight(); //preload
	
	(0, _module.preload)(); //toggleHeader
	
	(0, _module.toggleHeader)(); //pageTop
	
	(0, _module.pageTop)(); //showMovie
	// import {showMovie} from "../include/module";
	// showMovie();
	//tabSwitchingCampaign
	
	(0, _module.tabSwitchingCampaign)(); //anchorLink
	
	(0, _module.anchorLink)();
	$(window).on('load', function () {
	  bgNoise();
	  $('.anim_Item-first').each(function () {
	    $(this).addClass("show");
	  });
	  setTimeout(function () {
	    showItem();
	  }, 800);
	});
	
	function bgNoise() {
	  var canvas = document.getElementById('noise'),
	      ctx = canvas.getContext('2d');
	
	  function resize() {
	    canvas.width = window.innerWidth;
	    canvas.height = window.innerHeight;
	  }
	
	  resize();
	  window.onresize = resize;
	
	  function noise(ctx) {
	    var w = ctx.canvas.width,
	        h = ctx.canvas.height,
	        idata = ctx.createImageData(w, h),
	        buffer32 = new Uint32Array(idata.data.buffer),
	        len = buffer32.length,
	        i = 0;
	
	    for (; i < len;) {
	      buffer32[i++] = (255 * Math.random() | 0) << 24;
	    }
	
	    ctx.putImageData(idata, 0, 0);
	  }
	
	  var toggle = true; // added toggle to get 30 FPS instead of 60 FPS
	
	  (function loop() {
	    toggle = !toggle;
	
	    if (toggle) {
	      requestAnimationFrame(loop);
	      return;
	    }
	
	    noise(ctx);
	    requestAnimationFrame(loop);
	  })();
	}
	/*******************************************************
	
	showItem
	
	********************************************************/
	
	
	var showItem = function showItem() {
	  var targetPositionAdd;
	  targetPositionAdd = 30;
	  var scrollPosition = $(window).scrollTop();
	  $(window).on("load resize", function () {
	    windowW = $(window).width();
	    windowH = $(window).innerHeight();
	  }); //ファーストビュー内にあるアイテム
	
	  $('.anim_Item').each(function () {
	    var targetPosition = $(this).offset().top;
	
	    if (targetPosition < windowH + scrollPosition) {
	      $(this).addClass("show");
	    }
	  }); //ファーストビューより下にあるアイテム（スクロールで表示）
	
	  $(window).on('scroll', function () {
	    scrollPosition = $(window).scrollTop();
	    $('.anim_Item').each(function () {
	      var targetPosition = $(this).offset().top;
	
	      if (scrollPosition > targetPosition - windowH + targetPositionAdd) {
	        $(this).addClass("show");
	      }
	    }); //スクロール誘導矢印を消す
	    // $(".opening_Item").addClass("hidden");
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anchorLink = exports.tabSwitchingCampaign = exports.tabSwitching = exports.showImg = exports.showMovie = exports.pageTop = exports.preload = exports.toggleHeader = void 0;
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu');
	var $modal = $('#movie-Stage');
	var $content = $('#movie-Iframe'); // ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeader.classList.remove('closed');
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeader.classList.add('opened');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false;
	      setTimeout(function () {// $('#st-Header_Navi').css({'display':'none'});
	      }, 0);
	    }
	  }, false);
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var pageTop = function pageTop() {
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	
	    if (scrollPosition >= 70) {
	      $("#st-Top").removeClass('st-Top-Hidden');
	    } else {
	      $("#st-Top").addClass('st-Top-Hidden');
	    }
	  });
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 700;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var showMovie = function showMovie() {
	  // open
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	    $('#movie-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({
	        'display': 'none'
	      });
	      $content.children().remove();
	    }); //
	    // $modal.stop().fadeOut(300, function(){
	    //   $content.children('iframe').remove();
	    // });
	  });
	}; // ------------------------------------------------------------------------
	// showImg
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var showImg = function showImg() {
	  // open
	  $('.js-Img').on('click', function () {
	    var dataID = $(this).attr('data-img');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //img append
	      $content.append('<img src="' + dataID + '">'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	}; // ------------------------------------------------------------------------
	// tabSwitching
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showImg = showImg;
	
	var tabSwitching = function tabSwitching() {
	  $('.tab-item').on('click', function () {
	    var idx = $('.tab-item').index(this);
	    $(this).addClass('current').siblings('.tab-item').removeClass('current');
	    $(this).closest('.tab').prev('.panel').find('.panel-item').removeClass('is-show');
	    $('.panel-item').eq(idx).addClass('is-show');
	  });
	}; // ------------------------------------------------------------------------
	// tabSwitchingCampaign
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.tabSwitching = tabSwitching;
	
	var tabSwitchingCampaign = function tabSwitchingCampaign() {
	  $('.tab-item').on('click', function () {
	    var idx = $('.tab-item').index(this);
	    $(this).addClass('current').siblings('.tab-item').removeClass('current');
	    $(this).closest('.tab').next('.panel').find('.panel-item').removeClass('is-show');
	    $('.panel-item').eq(idx).addClass('is-show');
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.tabSwitchingCampaign = tabSwitchingCampaign;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 40;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  } //ページ内リンク
	
	
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 700;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 40;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	};
	
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// nextband/app.bundle.js